export default __webpack_public_path__ + "static/media/SF_fb.7b142f17.png";